$(document).ready(function () {
    /**
     * Handle a button click to load more blog posts
     *
     */
    function loadMoreBlogPosts(e, button) {
        e.preventDefault();
        var $button = $(button);
        var current_page_num = parseInt(button.getAttribute('data-page'), 10);
        var next_page_num = current_page_num + 1;

        $("#loadingOverlay").show();

        $.ajax({
            type: 'post',
            url: window.location.href,
            dataType: 'json',
            data: {
                ajax: true,
                listing_page: next_page_num,
            },
            success: function (response) {
                button.setAttribute('data-page', next_page_num);

                if ($.trim(response.result) != "") {
                    $('.blogListWrapper').append(response.result).fadeIn();
                }

                if (response.number < 6) {
                    $button.closest(".showMoreWrap").fadeOut();
                }
            }
        }).done(function () {
            $("#loadingOverlay").hide();
        });
    }

    /**
     * Load more blog posts
     *
     */
    var more_blog_posts_button = document.querySelector('.morePosts');

    if (more_blog_posts_button) {
        more_blog_posts_button.addEventListener('click', e => loadMoreBlogPosts(e, more_blog_posts_button));
    }

    /**
     * Carz Read More - simple toggle to show / hide hidden content
     */
    if ($('.js_carzReadMoreTrigger').length) {
        $('.js_carzReadMoreTrigger').on('click', function () {
            const parent = $(this).closest('.carzReadMoreWrap');
            parent.toggleClass('active');

            if (parent.hasClass('active')) {
                $(this).find('span').text('Read less')
            } else {
                $(this).find('span').text('Read more')
            }
        })
    }
});
